













import { Component, Vue, Prop } from 'vue-property-decorator';
import ShapeDiagonalBottomLeft from './shapes/ShapeDiagonalBottomLeft.vue';

@Component({
  components: {
    ShapeDiagonalBottomLeft,
  },
})
export default class BackgroundImage extends Vue {
  @Prop({ type: String, required: true }) private image!: string;
  @Prop({ type: Boolean, required: false, default: false }) private clear!: boolean;
}
